import { PRIVILEGES } from 'constants/privileges';
import { useEffect, useState } from 'react';
import { ResStatus } from 'api/api.types';
import { getCheckUnpublished } from 'api/invoices';
import {
  getAllAlertsState,
  useAlerts,
} from 'contexts/alertsContext/alertsContext';
import { useAuth } from 'contexts/authContext';
import { useTranslation } from 'react-i18next';
import { generatePath } from 'react-router-dom';
import {
  iframePaths,
  InvoiceTab,
  reactPaths,
  ReportsTab,
} from 'root/pathnames';
import { hasPrivilege } from 'utils/authFunctions.utils';
import { DashboardTile } from './components/DashboardTile';
import { NotificationList } from './components/Notifications';
import {
  NotificationAlert,
  NotificationLink,
} from './components/Notifications/Notifications.css';
import { reportsPrivileges } from './consts';
import { Dashboard, PageLayout, Title } from './DashboardScreen.css';

export const DashboardScreen = () => {
  const { user } = useAuth();
  const {
    dispatch,
    state: { alertsInbox },
  } = useAlerts();
  const [anyUnpublished, setAnyUnpublished] = useState({
    outdatedOwnInvoices: false,
    outdatedAdministrativeInvoices: false,
  });

  const { t } = useTranslation(['homePage', 'clientHomePage', 'menu', 'misc']);

  useEffect(() => {
    getAllAlertsState(dispatch);
  }, [dispatch]);

  useEffect(() => {
    !user?.clientPanelUser &&
      getCheckUnpublished().then((res) => {
        if (res.data.status === ResStatus.OK) {
          setAnyUnpublished(res.data.result);
        }
      });
  }, [user?.clientPanelUser]);

  return (
    <PageLayout>
      {!user?.clientPanelUser ? (
        <Title>{t('dashboard', { ns: 'homePage' })}</Title>
      ) : (
        <Title>{t('notifications', { ns: 'clientHomePage' })}</Title>
      )}
      {anyUnpublished.outdatedOwnInvoices && (
        <NotificationAlert severity='error'>
          {t('message.outdatedOwnInvoices', { ns: 'misc' })}
          <NotificationLink
            to={generatePath(reactPaths.invoicesModule, {
              tab: InvoiceTab.OWN,
            })}
          >
            {t('message.goToOutdatedInvoices', { ns: 'misc' })}
          </NotificationLink>
        </NotificationAlert>
      )}
      {anyUnpublished.outdatedAdministrativeInvoices && (
        <NotificationAlert severity='error'>
          {t('message.outdatedAdministrativeInvoices', { ns: 'misc' })}
          <NotificationLink
            to={generatePath(reactPaths.invoicesModule, {
              tab: InvoiceTab.ADMINISTRATIVE,
            })}
          >
            {t('message.goToOutdatedInvoices', { ns: 'misc' })}
          </NotificationLink>
        </NotificationAlert>
      )}
      {!!alertsInbox?.length && (
        <NotificationList notifications={alertsInbox} />
      )}
      <Dashboard>
        <div className='tilesRow'>
          {hasPrivilege(PRIVILEGES.Offers.VIEW_OFFER_LIST, user) && (
            <DashboardTile
              text={t('offers', { ns: 'menu' })}
              path={'/offers'}
              iconName='icons-new-copy2'
            />
          )}
          {hasPrivilege(PRIVILEGES.Jobs.VIEW_JOB_LIST, user) && (
            <DashboardTile
              text={t('jobs', { ns: 'menu' })}
              path={'/jobs'}
              iconName='icons-briefcase'
            />
          )}
        </div>
        <div className='tilesRow'>
          {hasPrivilege(PRIVILEGES.Invoices.VIEW_INVOICE_LIST, user) && (
            <DashboardTile
              text={t('invoices', { ns: 'menu' })}
              path={generatePath(reactPaths.invoicesModule, {
                tab: InvoiceTab.OWN,
              })}
              iconName='icon-dollar'
            />
          )}
          {reportsPrivileges.some((p) => hasPrivilege(p, user)) && (
            <DashboardTile
              text={t('reports', { ns: 'menu' })}
              path={generatePath(iframePaths.reportsTab, {
                tab: ReportsTab.ACTIVITY,
              })}
              iconName='icons-chart'
            />
          )}
        </div>
      </Dashboard>
    </PageLayout>
  );
};
